/**
 * Extracts the pathname segment that starts with "funnel-" from a URL
 * @param url - The URL string or Request object (optional, uses window.location on client)
 * @returns The funnel segment without slashes, or null if not found
 */
export function getFunnelIDFromURL(url?: string | URL | Request): string | undefined {
  let pathname: string;

  // Server-side: Accept URL string, URL object, or Request object
  if (url) {
    if (typeof url === "string") {
      try {
        pathname = new URL(url).pathname;
      } catch {
        // If it's just a pathname string (not a full URL)
        pathname = url;
      }
    } else if (url instanceof URL) {
      pathname = url.pathname;
    } else if (typeof Request !== "undefined" && url instanceof Request) {
      pathname = new URL(url.url).pathname;
    } else {
      pathname = "";
    }
  }
  // Client-side: Use window.location if available
  else if (typeof window !== "undefined" && window.location) {
    pathname = window.location.pathname;
  } else {
    return;
  }

  // Split pathname by slashes and find segment starting with "funnel-"
  const segments = pathname.split("/").filter((segment) => segment.length > 0);
  const funnelSegment = segments.find((segment) => segment.startsWith("funnel-"));

  return funnelSegment;
}
